module.exports = __webpack_public_path__ + "assets/img/allclients.8325459b.png";